import React from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import { formatNumber } from '@ion/mrdash';
import TextCell from 'app/components/data-table/TextCell';

export default function FormatNumberCell({ number, ...textCellProps }) {
  const text = !isNil(number) ? formatNumber(number) : null;
  return <TextCell text={text} {...textCellProps} />;
}

FormatNumberCell.propTypes = {
  number: PropTypes.number.isRequired,
};
